import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const apiBaseUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;

function formatApiError(detail) {
  if (!detail) {
    return "Something went wrong. Please try again.";
  }
  if (typeof detail === "string") {
    return detail;
  }
  if (Array.isArray(detail)) {
    return detail.map((item) => item.msg).filter(Boolean).join(" ");
  }
  return String(detail);
}

export default function EmailAuthForm({ mode, onSuccess }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isRegistering = mode === "register";

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);
    const payload = isRegistering ? { name, email, password } : { email, password };
    try {
      const response = await axios.post(
        `${apiBaseUrl}/${isRegistering ? "register" : "login"}`,
        payload,
        { withCredentials: true },
      );
      onSuccess(response.data.user);
    } catch (requestError) {
      setError(formatApiError(requestError.response?.data?.detail));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="email-auth-form" onSubmit={submit} data-testid="email-auth-form">
      {isRegistering && (
        <label className="auth-field" data-testid="register-name-field">
          <span>Your name</span>
          <input
            value={name}
            onChange={(event) => setName(event.target.value)}
            type="text"
            autoComplete="name"
            placeholder="Marcus Reed"
            minLength="2"
            required
            data-testid="register-name-input"
          />
        </label>
      )}
      <label className="auth-field" data-testid="email-field">
        <span>Email address</span>
        <input
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          type="email"
          autoComplete="email"
          placeholder="you@example.com"
          required
          data-testid="email-auth-email-input"
        />
      </label>
      <label className="auth-field" data-testid="password-field">
        <span>Password</span>
        <input
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          type="password"
          autoComplete={isRegistering ? "new-password" : "current-password"}
          placeholder="At least 8 characters"
          minLength="8"
          required
          data-testid="email-auth-password-input"
        />
      </label>
      {error && <p className="auth-error" data-testid="email-auth-error">{error}</p>}
      <button
        className="email-submit-button"
        type="submit"
        disabled={isSubmitting}
        data-testid="email-auth-submit-button"
      >
        {isSubmitting ? "Working…" : isRegistering ? "Create your account" : "Sign in"}
      </button>
      {!isRegistering && (
        <Link className="recovery-link" to="/forgot-password" data-testid="forgot-password-link">
          Forgot your password?
        </Link>
      )}
    </form>
  );
}